module.exports = __webpack_public_path__ + "img/profile.67ddcb83.svg";